<!--  -->
<template>
  <div>
    <div id="rightdiv">
      <ul class="lit03">
        <li v-for="item in xwlb" :key="item.newsId">
          <div class="cont_r_b04">
            <div class="cont_r_b05">
              <router-link :to="'/profilezh/xwxqzh/'+item.newsId">
                <img :src="item.url" width="158" height="109">
              </router-link>
            </div>
            <div class="cont_r_b06">
              <div class="cont_r_b07">
                <p>
                  <router-link :to="'/profilezh/xwxqzh/'+item.newsId">{{item.title}}</router-link>
                </p>
              </div>
              <div class="cont_r_b08">
                <p></p>
                <p>
                  <span style="line-height:1.5;color:#337FE5;">
                    <strong>
                      <br>
                    </strong>
                  </span>
                </p>
                <p v-html="item.summary"></p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xwlb: ""
    };
  },

  components: {},
  mounted: function() {
    this.getxwlb();
  },
  methods: {
    getxwlb() {
      this.$http
        .get("SSM-master/marcoNews/getListInChinese")
        .then(response => {
          this.xwlb = response.data;
          response => {
            console.log("出错了");
          };
        });
    }
  }
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/profile/alxw.vue